<template>
  <BulmaMessage v-if="hasErrors"
    :value="hasErrors"
    :closable="true"
    :icon="iconName"
    :iconColor="iconColor"
    @close="exit">
    <template #title>
      <span>
        {{ errorTitle }}
        <span v-show="errors.length > 1"
          class="ml-1">
          ({{ index + 1 }} of {{ errors.length }})
        </span>
      </span>
    </template>

    <template>
      <p class="my-4">
        <span style="white-space: pre-wrap;">{{ errors[index].message }}</span>
      </p>

      <div>
        <div class="technical-details-toggle has-text-weight-light"
          @click="showPanel = !showPanel">
          <span>Technical Details</span>
          <span class="msr msr-24px"
            :class="{ 'is-open': showPanel }">
            {{ showPanel ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
          </span>
        </div>

        <div class="box mt-3 p-1"
          v-show="showPanel">

          <article class="message">
            <div class="message-body py-2 px-2"
              style="border: 1px solid var(--bulma-border);">
              <table class="table is-fullwidth is-size-7">
                <tbody>
                  <tr v-if="errors[index].id > 0">
                    <td>
                      <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Error ID:</span>
                        <span>{{ errors[index].id }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="errors[index].statusCode">
                    <td>
                      <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Status Code:</span>
                        <span>{{ errors[index].statusCode }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="errors[index].timestamp">
                    <td>
                      <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Timestamp:</span>
                        <span>{{ $filters.formatDateTimeLocale(errors[index].timestamp, $userInfo.locale) }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="errors[index].statusCode && !showRaw && errors[index].url">
                    <td>
                      <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Endpoint:</span>
                        <span>{{ errors[index].url }}</span>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr v-if="errors[index].statusCode && !showRaw && errors[index].data !== errors[index].message">
                    <td>
                      <div class="is-flex is-justify-content-space-between is-align-items-center">
                        <span>Data:</span>
                        <span>{{ errors[index].data }}</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="errors[index].statusCode && showRaw">
                    <td>
                      <div class="field"
                        style="width: 100%;">
                        <label class="is-size-7">Data:</label>
                        <div class="control">
                          <div class="box"
                            style="background-color: var(--bulma-background);">
                            <span v-html="errors[index].data.replace('font-family:', ':')"
                              style="white-space: pre-wrap;" />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </article>

        </div>
      </div>

    </template>

    <template #footer>
      <div class="level is-flex-grow-1 mt-0 mb-0">
        <div class="level-left">
          <button v-if="index > 0"
            class="button is-primary"
            @click="index--">
            Previous
          </button>
        </div>
        <div v-show="errors.length > 1"
          class="level-item has-text-centered">
          <span class="tag">
            {{ index + 1 }} / {{ errors.length }}
          </span>
        </div>
        <div class="level-right">
          <button v-if="index < errors.length - 1"
            class="button is-primary"
            @click="index++">
            Next
          </button>
          <button v-else
            class="button is-primary"
            @click="exit">
            Dismiss
          </button>
        </div>
      </div>
    </template>
  </BulmaMessage>
</template>

<script>
import BulmaMessage from '@/components/BulmaMessage/BulmaMessage.vue'

export default {
  name: 'AppErrors',
  components: {
    BulmaMessage
  },
  props: {
    showRaw: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 0,
      showPanel: false
    }
  },
  computed: {
    errors: function () {
      return this.$store.getters['errors/all']
    },
    hasErrors: function () {
      return !!this.$store.getters['errors/hasErrors']
    },
    errorTitle: function () {
      const error = this.errors[this.index]
      if (!error || !error.errorCode) {
        return 'Unable to Complete Request'
      }
      const titles = {
        'VALIDATION': 'Action Required',
        'BUSINESS_RULE': 'Cannot Continue',
        'INTEGRATION': 'Temporary System Issue'
      }
      return titles[error.errorCode] || 'Unable to Complete Request'
    },
    iconName: function () {
      const error = this.errors[this.index]
      if (!error || !error.errorCode) {
        return 'error'
      }
      const icons = {
        'VALIDATION': 'warning',
        'BUSINESS_RULE': 'do_not_disturb_on',
        'INTEGRATION': 'sync'
      }
      return icons[error.errorCode] || 'error'
    },
    iconColor: function () {
      const error = this.errors[this.index]
      if (!error || !error.errorCode) {
        return '#D92550' //red
      }
      const colors = {
        'VALIDATION': '#FFCC00', //amber
        'INTEGRATION': '#FFCC00' //amber
      }
      return colors[error.errorCode] || '#D92550' //red
    }
  },
  watch: {
    hasErrors(value) {
      if (value) {
        this.$resetSpinner()
      }
    }
  },
  mounted() {},
  methods: {
    exit() {
      this.$store.dispatch('errors/purge')
      this.index = 0
    }
  }
}
</script>

<style scoped lang="scss">
.level {
  margin-bottom: 0;
}

.technical-details-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0.5rem;
  border-top: 1px solid #dbdbdb;
  cursor: pointer;

  .chevron {
    font-size: 1rem;
    transition: transform 0.2s ease;
    transform: rotate(90deg);

    &.is-open {
      transform: rotate(-90deg);
    }
  }
}
</style>
